// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1vozh","title":"AfterFrontImage_title__1KL0N"};